const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    changePassword: `${API_URL}/user/change-password`
};

export default apiUrls;
